import type { AllRouteEndpoints } from "../routeTypes";

export const engagementWebhookTemplatesIdCacheKeys: AllRouteEndpoints[] = ["/engagement/webhook_templates/:id"];
